import VueRouter from 'vue-router'
import HomePage from '../components/HomePage.vue'
import Setup from '../components/Setup.vue'



export default new VueRouter({
    routes: [
        {
            path: '/',
            name: 'HomePage',
            component: HomePage,
            meta: {
              title: 'cogvis Setup'
            },
        },
        {
            path: '/setup',
            name: 'Setup',
            component: Setup,
            props: true,
            meta: {
              title: 'cogvis Setup'
            }
        }
    ]
})
